export { default } from "./Select";


// WEBPACK FOOTER //
// ./src/ui-kit/components/select/index.js